export default "__VITE_ASSET__DDwG_KFN__"